"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuplicateModelSignalMappingError = void 0;
exports.findDuplicateModelSignalMappings = findDuplicateModelSignalMappings;
exports.assertUniqueModelSignalMappings = assertUniqueModelSignalMappings;
const array_submodels_1 = require("../../../../../PackageStore/ComponentArrays/array-submodels");
function findDuplicateModelSignalMappings(args) {
    const definition = args.getFormDefinition(args.parentType);
    if (definition === null) {
        return [];
    }
    const singleUse = new Set(definition.signals
        .filter((signal) => signal.allowMultiMapping !== true && signal.repeatableBlock === null)
        .map((signal) => String(signal.id)));
    const elementConfig = args.elementType === '' ? null : (0, array_submodels_1.getArrayElementConfig)(args.elementType);
    const elementTerminalName = elementConfig === null ? null : new RegExp(`^${elementConfig.prefix}\\d+_`);
    const elementTerminals = elementConfig === null ? undefined : (args.getFormDefinition(args.elementType)?.signals.map((signal) => String(signal.id)));
    const isElementTerminal = (name, ref) => elementTerminalName?.test(name) === true && (elementTerminals === undefined || elementTerminals.includes(ref));
    const holders = new Map();
    for (const signal of args.signals) {
        if (signal.modelSignal === undefined || signal.modelSignal === null) {
            continue;
        }
        const ref = String(signal.modelSignal);
        if (!singleUse.has(ref) || isElementTerminal(signal.name, ref)) {
            continue;
        }
        const names = holders.get(ref);
        if (names === undefined) {
            holders.set(ref, [signal.name]);
        }
        else {
            names.push(signal.name);
        }
    }
    const toleratedHolders = new Map((args.tolerated ?? []).map((mapping) => [mapping.modelSignal, new Set(mapping.signalNames)]));
    return [...holders]
        .filter(([modelSignal, signalNames]) => {
        const before = toleratedHolders.get(modelSignal);
        return signalNames.length > 1 && (before === undefined || signalNames.some((name) => !before.has(name)));
    })
        .map(([modelSignal, signalNames]) => ({ modelSignal, signalNames }));
}
function assertUniqueModelSignalMappings(args) {
    const duplicates = findDuplicateModelSignalMappings(args);
    if (duplicates.length > 0) {
        throw new DuplicateModelSignalMappingError(duplicates, args.parentType);
    }
}
class DuplicateModelSignalMappingError extends Error {
    constructor(mappings, sigmaModelType) {
        const described = mappings
            .map((mapping) => `Model signal '${mapping.modelSignal}' is mapped to ${mapping.signalNames.join(', ')}.`)
            .join(' ');
        super(`${described} The ${sigmaModelType} model takes one package signal on each of these, so the ` +
            'simulation could not tell them apart. Remap or unmap all but one.');
        this.name = 'DuplicateModelSignalMappingError';
        this.mappings = mappings;
    }
}
exports.DuplicateModelSignalMappingError = DuplicateModelSignalMappingError;
//# sourceMappingURL=model-signal-uniqueness.js.map